(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Agenzia', Agenzia);

    Agenzia.$inject = ['$resource'];

    function Agenzia ($resource) {
        var resourceUrl =  'api/agenzias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
